import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';

import {resolveBackground} from '#core/utils/color-utils.js';

import {
    generatePrimaryButton,
    generateSecondaryButton,
    generateTertiaryButton,
} from '#core/application/modules/tiles/button/index.js';

const AuthenticationTypes = MojitoServices.Authentication.types;
const AuthenticationActions = MojitoServices.Authentication.actions;
const {dispatch} = MojitoCore.Services.redux.store;

export function alertDialogConfig(PALETTE) {
    const ALERT_DIALOG_CONFIRM_BUTTON = generatePrimaryButton(PALETTE.ALERT_DIALOG_CONFIRM_BUTTON);

    return {
        AlertMessageView: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.ALERT_DIALOG_BG),
                    borderRadius: PALETTE.ALERT_DIALOG_CONTAINER_BORDER_RADIUS,
                    boxShadow: PALETTE.ALERT_DIALOG_CONTAINER_SHADOW,
                    padding: 0, // override mojito defaults
                    ...PALETTE.ALERT_DIALOG_MESSAGE_TEXT,
                },
            },
            buttonsContainer: {
                style: {
                    justifyContent: 'right',
                },
            },
            headerLabel: {
                style: {
                    ...PALETTE.ALERT_DIALOG_TITLE_TEXT,
                },
            },
            style: {
                messageText: {
                    ...PALETTE.ALERT_DIALOG_MESSAGE_TEXT,
                },
            },
            //buttonBase: // Please leave it empty. Because it has unwanted influence to other buttons
            countDownTimerContainer: {
                style: {
                    ...PALETTE.ALERT_DIALOG_COUNTDOWN_TIMER_TEXT,
                },
            },
        },
        AlertMessageViewTypes: {
            simpleAlert: {
                buttonsConfig: {
                    ok: {
                        button: ALERT_DIALOG_CONFIRM_BUTTON,
                    },
                },
            },
            lastLoginAlert: {
                buttonsConfig: {
                    ok: {
                        button: ALERT_DIALOG_CONFIRM_BUTTON,
                    },
                },
            },
            sessionLimitAlert: {
                showCountDownTimer: true,
                countDownTimerLimit: 2 * 60,
                countDownTimerLabel: '$ALERT_MESSAGE.AUTO_LOGOUT_LABEL',
                countDownTimerExpiredAction: () =>
                    dispatch(AuthenticationActions.logout(AuthenticationTypes.LOGOUT_REASON.SESSION_EXPIRED)),
                buttonsConfig: {
                    stopgaming: {
                        action: () =>
                            dispatch(AuthenticationActions.logout(AuthenticationTypes.LOGOUT_REASON.MANUAL_LOGOUT)),
                        button: generateTertiaryButton(PALETTE.ALERT_DIALOG_SESSION_LIMIT_STOP_GAMING_BUTTON),
                    },
                    reset: {
                        button: generatePrimaryButton(PALETTE.ALERT_DIALOG_SESSION_LIMIT_RESET_BUTTON),
                    },
                },
            },
        },
        InactivityDialogView: {
            dialog: {
                background: {
                    ...resolveBackground(PALETTE.ALERT_DIALOG_BG),
                },
                _mobile_layoutType: 'centered',
                centered: {
                    width: '360px',
                    _mobile_width: 'calc(100% - 32px)',
                },
                contentContainer: {
                    padding: '24px 8px 8px 8px',
                },
                header: {
                    titleText: {
                        ...PALETTE.ALERT_DIALOG_TITLE_TEXT,
                    },
                },
            },
            timer: {
                timerWrapper: {
                    style: {
                        ...PALETTE.ALERT_DIALOG_TIMER_TEXT,
                    },
                },
            },
            style: {
                containerText: {
                    ...PALETTE.ALERT_DIALOG_MESSAGE_TEXT,
                },
            },
            buttonsContainer: {
                style: {
                    padding: '24px 0px 0px 0px',
                    _mobile_padding: '16px 0px 0px 0px',
                },
            },
            logoutButton: generateSecondaryButton(PALETTE.ALERT_DIALOG_INACTIVITY_LOGOUT_BUTTON),
            stayLoggedInButton: generatePrimaryButton(PALETTE.ALERT_DIALOG_INACTIVITY_STAY_LOGGED_IN_BUTTON),
        },
    };
}
